import { useTranslation } from '../../i18n/LocaleContext';

export default function TradeConfirmModal({
  open,
  title,
  message,
  confirming = false,
  onConfirm,
  onClose,
}) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <div className="trade-modal trade-modal--center">
      <button
        type="button"
        className="trade-modal__backdrop"
        aria-label={t('common.close')}
        onClick={() => !confirming && onClose?.()}
      />
      <div className="trade-modal__panel trade-modal__panel--compact trade-confirm-modal">
        <header className="trade-modal__header">
          <h2>{title || t('common.hint')}</h2>
          <button
            type="button"
            className="trade-modal__close"
            aria-label={t('common.close')}
            disabled={confirming}
            onClick={onClose}
          >
            ×
          </button>
        </header>
        <p className="trade-confirm-modal__message">{message}</p>
        <div className="trade-confirm-modal__actions">
          <button
            type="button"
            className="trade-confirm-modal__btn is-outline"
            disabled={confirming}
            onClick={onClose}
          >
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="trade-confirm-modal__btn is-solid"
            disabled={confirming}
            onClick={onConfirm}
          >
            {t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}
